'use client';

import clsx from 'clsx';
import { FieldError } from 'react-hook-form';

import { BasicBin, BasicCheck, BasicClose } from '../../../../icons/basic';
import { IconButton } from '../../../buttons/IconButton';
import { Typography } from '../../../typography/Typography';
import { FormMessage, useFormField } from '../../FormField';
import { Preview } from './Preview';
import { PreviewDialog } from './PreviewDialog';

export type UploadedFileProps = {
  file: File,
  onDelete: (file: File) => void,
  error?: FieldError,
  showPreview?: boolean,
};

export function UploadedFile({
  file,
  onDelete,
  error,
  showPreview,
}: UploadedFileProps) {
  const { formMessageId } = useFormField();

  const wrapperClasses = clsx('flex w-full min-w-0 items-center justify-between border bg-upload-uploaded text-upload-uploaded', {
    'border-upload-uploaded': !error,
    'border-upload-error': error,
  });

  return (
    <>
      <div className={wrapperClasses}>
        {showPreview && (
          <Preview
            file={file}
            error={!!error}
          />
        )}
        <div className="flex min-w-0 flex-1 items-center justify-between p-2">
          {error ? (
            <BasicClose className="mr-2 size-7 text-error" />
          ) : (
            <BasicCheck className="mr-2 size-7 text-upload-uploaded-status-icon" />
          )}
          <Typography
            marginClassname="mr-auto"
            textColorClassname="text-upload-uploaded"
            variant="content-body"
            className="min-w-0 flex-1 truncate"
          >
            {file.name}
          </Typography>
          {showPreview && (
            <PreviewDialog
              file={file}
              error={!!error}
            />
          )}
          <IconButton
            icon={<BasicBin />}
            className="text-upload-uploaded-icon"
            label={`Verwijder bestand: ${file.name}`}
            onClick={() => onDelete(file)}
          />
        </div>
      </div>
      {error && (
        <FormMessage
          id={formMessageId}
          errorBody={error.message}
        />
      )}
    </>
  );
}
